import React from "react";
import MemberConfigEdit from 'containers/memberConfig/memberConfigEdit';
import axios from 'axios';
import '../../form.css';

import { Table, Tag, Typography, Button, Layout, Row, Col, Divider, Spin, Space, Popconfirm, message } from 'antd';
import {
    DeleteOutlined,
    EditOutlined,
    PlusOutlined,
    ReloadOutlined,
} from '@ant-design/icons';

const { Content } = Layout;
const { Title } = Typography;

export default class MemberList extends React.Component {

    constructor(props: any) {
        super(props);
        this.getMembers();
    }

    state = {
        memberData: [],
        userInfo: [],
        loading: true,
        total: 0,
        dataId: 0,
        editorVisible: false,
        editorTitle: "Modal Title"
    };

    getMembers = () => {
        axios.get('https://www.fastmock.site/mock/9973669a2a13cbb70690fdf6f1880e97/admin/memberConfig/list', {
            params: {}
        })
            .then((res) => {
                console.log('res', res.data.data.list)
                this.setState({
                    memberData: res.data.data.list,
                    total: res.data.data.total,
                    loading: false
                })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    columns = [
        {
            title: 'ID',
            dataIndex: 'id'
        },
        {
            title: '会员等级',
            dataIndex: 'level',
        },
        {
            title: '等级名称',
            dataIndex: 'name',
        },
        {
            title: '猫粮抵扣上限（人民币）',
            dataIndex: 'limitOfDeduction',
        },
        {
            title: '购买上限（人民币）',
            dataIndex: 'limitOfBuy',
        },
        {
            title: '会员福利',
            dataIndex: 'benefits',
        },
        {
            title: '操作',
            dataIndex: 'id',
            render: (text: number) =>
                <Space>
                    <Button type="primary" shape="round" onClick={this.editData.bind(this, text)}><EditOutlined />编辑</Button>
                    <Popconfirm placement="left" title="确认删除此条记录吗？" onConfirm={this.deleteConfirm.bind(this, text)} okText="确认" cancelText="取消">
                        <Button shape="round" ><DeleteOutlined />删除</Button>
                    </Popconfirm>
                </Space>
            ,
        }
    ];

    // 新增
    createData = () => {
        this.setState({
            editorVisible: true,
            editorTitle: "新增配置"
        });
    };

    // 编辑
    editData = (text: number): any => {
        this.setState({
            dataId: text,
            editorVisible: true,
            editorTitle: "编辑配置 ID - " + text.toString()
        });
    }

    // 关闭 Modal
    cancelModal = () => {
        this.setState({
            editorVisible: false,
        });
    };

    // 删除确认
    deleteConfirm = (text: number): any => {
        message.warning("删除了id" + text.toString());
    }

    render() {
        let userInfo: any = this.state.userInfo;
        console.log('userInfo', userInfo);
        return (
            <div>
                <div className="page-title">
                    <Title level={3}>会员配置</Title>
                </div>

                <Divider />

                <Row gutter={[18, 24]}>
                    <Col><Button type="primary" onClick={this.createData}><PlusOutlined /> 新增配置</Button></Col>
                    <Col><Button onClick={() => { window.location.reload() }} ><ReloadOutlined /> 刷新</Button></Col>
                </Row>
                <Spin tip="Loading..." size="large" spinning={this.state.loading}>
                    <Table
                        columns={this.columns}
                        dataSource={this.state.memberData}
                        pagination={{
                            total: this.state.total,
                            position: ["bottomLeft"],
                        }}
                    />
                </Spin>
                <MemberConfigEdit dataId={this.state.dataId} editorVisible={this.state.editorVisible} editorTitle={this.state.editorTitle} onCancel={this.cancelModal} ref="child" />
            </div >
        );
    }
}
